module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("Feb. 12")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Saturday is Valentine’s Day.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So we will be allowed to celebrate it at school TOMORROW, Friday.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Unless you don’t have a Valentine. Like me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then you don’t celebrate. You walk around feeling sorry for yourself. You might as well stay home.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But look on the bright side, McCrae.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tomorrow also happens to be Friday the 13th.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So maybe having a Valentine is unlucky. And the best thing to do is go to school and don’t worry.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You will not worry.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You will not worry.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You will not worry.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c25a4fa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/v5/4chap1.vue
// module id = 72
// module chunks = 0